import { useParams } from "react-router"
import styled from "styled-components"

import { parseNumber } from "@forento/shared/utilities/number"

import Layout from "~/themes/school/components/Layout"
import { PageTitle } from "~/themes/school/components/PageHeader"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import Post from "~/themes/school/components/Post"
import { useTranslation } from "~/translations"
import { query } from "~/utilities/trpc"

import Profile from "./Profile"

const ProfilePage: React.FC = () => {
	const profileId = parseNumber(useParams().profileId ?? "") ?? -1
	const t = useTranslation()

	const profile = query.community.getProfile.useQuery(profileId)
	const posts = query.community.listPersonalizedPostsByProfile.useQuery(profileId)

	return (
		<Layout>
			<PageTitle>{t("community.profile")}</PageTitle>
			<Content>
				{profile.error || posts.error ? (
					t("failedToLoad")
				) : profile.data === undefined || posts.data === undefined ? (
					<PartialLoadingPage />
				) : profile.data === null ? (
					t("community.profileNotFound")
				) : (
					<>
						<Profile profile={profile.data} />
						<Posts>
							{[...posts.data]
								.sort((a, b) => b.createDate.getTime() - a.createDate.getTime())
								.map(x => (
									<Post key={x.id} post={x} onChange={posts.refetch} showChannel />
								))}
						</Posts>
					</>
				)}
			</Content>
		</Layout>
	)
}

const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 42px;

	@media (min-width: 1000px) {
		flex-direction: row;
		align-items: flex-start;
	}
`

const Posts = styled.div`
	flex: 2 0 0;
	display: flex;
	flex-direction: column;
	gap: 32px;
`

export default ProfilePage
